import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { useSelector } from 'react-redux';
import { selectCompanyGuid } from '../../features/auth/authSlice';

export default function SimpleFileUpload() {
    const toast = useRef(null);
    const companyGuid = useSelector(selectCompanyGuid)

    const onUpload = () => {
        toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
    };
        
    return (
        <div className="card flex justify-content-center">
            <Toast ref={toast}></Toast>
            <FileUpload 
            mode="basic" 
            name="files" 
            url={`http://localhost:8080/api/file/upload/${companyGuid}`}
            accept="image/*" 
            maxFileSize={1000000} 
            onUpload={onUpload} />
        </div>  
    )
}